import { render, staticRenderFns } from "./OperationsHistoryParent.vue?vue&type=template&id=17c68068"
import script from "./OperationsHistoryParent.vue?vue&type=script&lang=js"
export * from "./OperationsHistoryParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports